import React, { memo } from 'react';
import styled from 'styled-components';

import FlexibleIcon from 'assets/v2/FlexibleIcon';
import { COLORS } from 'theme';
import { BOOKING_TYPE_TIME_LABELS } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.greenPigmentDark};
    background: ${COLORS.greenPigmentLight};
    border-color: ${COLORS.greenPigment};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.greenPigment};
    }
  }
`;

function WillCallBookingTypeTag(props) {
  return (
    <StyledTag
      label={BOOKING_TYPE_TIME_LABELS.WILLCALL}
      icon={<FlexibleIcon />}
      {...props}
    />
  );
}

export default memo(WillCallBookingTypeTag);
